










import { Component, Mixins } from "vue-property-decorator";

// Mixins
import BillableEntitiesInjectorMixin from "@/mixins/billableEntitiesInjectorMixin";

@Component({
  components: {
    "address-search": () =>
      import("@/components/app/global/address/addressSearch.vue")
  }
})
export default class CProdBillableEntityActions extends Mixins(
  BillableEntitiesInjectorMixin
) {
  // Data
  public addingAddress = false;
  public addressSearchedKey = this.$uuid();
  public searchedValue = "";

  // Methods

  public async onAddressSearchResult(address, searchedValue) {
    this.$billableEntitiesMethods.manageClientAddress({
      address: {
        ...address,
        name: address.address_1,
        type: 1,
        default: true
      },
      searchedValue,
      config: {
        events: {
          success: async address => {
            await this.$billableEntitiesMethods.refreshAddresses();
            this.clearAddressSearch();
            this.$bus.$emit("selectBillableEntity", address);
          }
        }
      }
    });
  }

  public clearAddressSearch() {
    this.addingAddress = false;
    this.$set(this, "searchedValue", "");
    this.addressSearchedKey = this.$uuid();
  }
}
